import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SingleCalendar from 'Components/SingleCalendar';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import TextField from 'Components/forms/text-field/TextField';
import DateIcon from 'Components/icons/DateIcon';

import './DaysLeftCalendar.scss';

class DaysLeftCalendar extends Component {
  constructor(props) {
    super(props);
    this.attachBindings();
  }

  attachBindings() {
    this.applyDate = this.applyDate.bind(this);
  }
  get labelContent() {
    return (
      <span style={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}>
        {this.props.labelDescription}
        {this.props.error && <span className="message-error">{this.props.error}</span>}
      </span>
    );
  }

  applyDate(id, value) {
    this.optionsBoxPopup && this.optionsBoxPopup.toggle();
    this.props.handleSingleDateChange(id, value);
  }

  render() {
    return (
      <div className="align-calendar">
        <TextField
          fieldClass="field range-container dual-date-input"
          labelContent={this.labelContent}
          htmlFor="pend"
          extraStyle={{ width: '50'}}
          labelClass="calender-label"
        >
          <OptionBoxPopup
            icon={DateIcon}
            triggerText={this.props.pendDate === undefined ? <div className="align-date">
              <span className="days-style" style={{ marginRight: '4', color: '#262aff', fontWeight: '500' }}>Select Date</span></div> : <div className="align-date">
                <span className="date-style">{this.props.pendDate}
                </span><span className="days-style">({this.props.daysLeft} Days)</span></div>}
            ref={(ref) => { this.optionsBoxPopup = ref; }}
          >
            <SingleCalendar
              dateFormat={this.props.dateFormat || "MM/DD/YYYY"}
              id="pendDate"
              minDate={moment(new Date()).format('MM/DD/YYYY')}
              maxDate={moment(this.props.cardBrandDueDate).subtract(6, "days").format("MM/DD/YYYY")}
              onApply={this.applyDate}
              onRef={(ref) => (this.child = ref)}
            />

          </OptionBoxPopup>
        </TextField>
      </div>
    );
  }
}

DaysLeftCalendar.props = {
  handleSingleDateChange: PropTypes.func,
  pendDate: PropTypes.string.isRequired,
  daysLeft: PropTypes.string.isRequired,
  labelDescription: PropTypes.string,
  dateFormat: PropTypes.string.isRequired,
  cardBrandDueDate : PropTypes.string,
};

DaysLeftCalendar.defaultProps = {
  text: '',
  cardBrandDueDate: "01/01/2199"
};

export default DaysLeftCalendar;
